import React from "react";

const Security = () => {
  return (
    <div className="profile-top-area">
      <label className="profile-label">Security</label>
    </div>
  );
};

export default Security;
